import React from 'react'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'
import ReactCodeInput from 'react-code-input'
import { inject, observer } from 'mobx-react'

import { APIURL } from '/constants'
import FormikField from '/components/forms/FormikField'
import LoadingButton from '/components/common/LoadingButton'
import services from '/components/services'

import { VisbilityContainer, CommonPose } from '../home/Animations'

export const EmailForm = inject('store')(
  observer(({ store, onComplete }) => {
    const handlePost = async (values, setErrors, setSubmitting) => {
      try {
        const res = await services.post_v2(APIURL.API_LAZY_LINK_SEND, values)
        if (res.statusCode === 200) {
          store.setupSession(null, res)
          if (onComplete) {
            onComplete(res.response)
          }
        } else if (res.statusCode === 500) {
          setErrors({
            global:
              'Unable to submit the form at this time. Please try again later'
          })
        } else {
          setErrors({
            global: res.message
          })
        }
      } catch (e) {
        console.error(e)
      }
      setSubmitting(false)
    }
    return (
      <VisbilityContainer>
        <Panel>
          <Formik
            initialValues={{
              email: ''
            }}
            validationSchema={Yup.object({
              email: Yup.string().required('Required')
            })}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
              await handlePost(values, setErrors, setSubmitting)
            }}
          >
            {({ isSubmitting, errors }) => (
              <Form>
                {errors.global && (
                  <Errors dangerouslySetInnerHTML={{ __html: errors.global }} />
                )}
                <CommonPose className="text-center">
                  <P>To access the deal, please enter your email address.</P>
                  <FormikField name="email">
                    <Field
                      className="form-control"
                      name="email"
                      placeholder="Email"
                      type="email"
                      autoFocus
                    />
                  </FormikField>
                </CommonPose>
                <Action className="text-center">
                  <LoadingButton text="Continue" isLoading={isSubmitting} />
                </Action>
              </Form>
            )}
          </Formik>
        </Panel>
      </VisbilityContainer>
    )
  })
)

export const LazyForm = ({ onComplete }) => {
  return <EmailForm onComplete={onComplete} />
}

const Errors = styled.div`
  text-align: center;
  font-weight: bold;
  padding: 10px 0;
  color: ${(props) => props.theme.colors.danger};
  margin: 0 auto;
  font-weight: 400;
`

const Action = styled(CommonPose)`
  padding: 20px 0;
`

const Panel = styled.div`
  max-width: 350px;
`

const P = styled.p`
  padding: 0 0 20px 0;
`
